import { Grid, useEventCallback } from '@mui/material';
import { memo, useMemo, useState } from 'react';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { LastStepVM, SectionVM } from 'civil-status/view-models/step-form';
import ListTemplateTranscription, { ItemTemplateVM } from '../list/list-template-transcription';
import PmiTextField from 'shell/components/shared/text-field';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { FormControlLabel } from '@mui/material';
import { Checkbox } from '@mui/material';
import { CodeSection } from 'civil-status/constants/code-subject-section';

interface ActCompositionProps {
  formContext: FormikProps<LastStepVM>;
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  tipoEvento?: string;
  idUseCase?: string;
  idEvento?: number;
  keySection?: string;
}

const ActCompositionComponent = ({
  formContext,
  disabled = false,
  values,
  errors,
  touched,
  idUseCase,
  idEvento,
  onChange,
  keySection = '',
  configuration,
}: ActCompositionProps): React.ReactElement => {
  const isComblib02 = useMemo(() => {
    return configuration === ConfigurationType.COMPLIB02;
  }, [configuration]);

  const isComblib03 = useMemo(() => {
    return configuration === ConfigurationType.COMPLIB03;
  }, [configuration]);

  const [checkisNotCertifiable, setCheckisNotCertifiable] = useState(
    values?.isNotCertifiable ?? values?.codeSection === CodeSection.ANNOTAZIONE_MODIFICATIVA
  );

  const handleListTemplateTranscriptionChange = useEventCallback((value?: ItemTemplateVM) => {
    setCheckisNotCertifiable(value?.codiceGenere === '1');
    formContext.setValues({
      ...(formContext.values || {}),
      [keySection]: {
        ...values,
        templateTranscription: value?.id?.toString(),
        actComposition: value?.valueTemplate || '',
        isNotCertifiable: value?.codiceGenere === '1',
      },
      textAct: {
        ...(formContext.values?.textAct || {}),
        text: isComblib03 ? formContext.values?.textAct?.text : value?.valueTemplate || '',
      },
    });
  });

  const onChangeActComposition = useEventCallback((valueNew?: string) => {
    formContext.setValues({
      ...(formContext.values || {}),
      [keySection]: {
        ...values,
        actComposition: valueNew,
      },
      textAct: {
        ...(formContext.values?.textAct || {}),
        text: valueNew,
      },
    });
  });

  // eslint-disable-next-line no-console
  console.log('checkisNotCertifiable', checkisNotCertifiable);
  // eslint-disable-next-line no-console
  console.log('values?.isNotCertifiable', values?.isNotCertifiable);

  return (
    <Grid container spacing={2} item>
      {isComblib02 ? (
        <Grid item xs={12} md={4}>
          <FormControlLabel
            control={
              <Checkbox
                id="isNotCertifiable"
                checked={checkisNotCertifiable}
                onChange={() => {
                  const newValueCheck = !checkisNotCertifiable;
                  setCheckisNotCertifiable(newValueCheck);
                  onChange('isNotCertifiable', newValueCheck);
                }}
                inputProps={{ 'aria-label': 'Dichiara come non certificabile' }}
              />
            }
            label="Dichiara come non certificabile"
          />
        </Grid>
      ) : undefined}
      <Grid item xs={12}>
        <ListTemplateTranscription
          value={values?.templateTranscription || ''}
          onChange={handleListTemplateTranscriptionChange}
          idUseCase={idUseCase}
          idEvento={idEvento}
          disabled={disabled}
          error={Boolean(errors?.templateTranscription) && touched?.templateTranscription}
          idDominio="102"
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Composizione dell'atto *"
          aria-label="Composizione dell'atto"
          id="actComposition"
          name="actComposition"
          fullWidth
          disabled={disabled}
          helperText={errors?.actComposition}
          error={touched?.actComposition && Boolean(errors?.actComposition)}
          type="text"
          multiline
          rows={5}
          variant="outlined"
          value={values?.actComposition || ''}
          onChange={(event) => {
            onChangeActComposition(event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

ActCompositionComponent.displayName = 'Form Act Composition component';

const ActComposition = memo(ActCompositionComponent);

export default ActComposition;
